class BlakmintHomepage extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized) return;
    this.dataset.initialized = 'true';

    try {
      this.initReviews();
    } catch (err) {
      console.error('[blakmint-homepage] reviews carousel failed to init', err);
    }

    try {
      this.initTwist();
    } catch (err) {
      console.error('[blakmint-homepage] twist pause/play failed to init', err);
    }

    try {
      this.initSwitchScroll();
    } catch (err) {
      console.error('[blakmint-homepage] switch scroll failed to init', err);
    }

    try {
      this.initCompareSlider();
    } catch (err) {
      console.error('[blakmint-homepage] compare slider failed to init', err);
    }

    try {
      this.initLogoDock();
    } catch (err) {
      console.error('[blakmint-homepage] logo dock failed to init', err);
    }
  }

  initReviews() {
    const reviewsTrack = document.getElementById('reviewsTrack');
    const reviewsPrev = document.getElementById('reviewsPrev');
    const reviewsNext = document.getElementById('reviewsNext');
    if (!reviewsTrack || !reviewsPrev || !reviewsNext) return;
    const reviewCards = Array.from(reviewsTrack.querySelectorAll('.review-card'));

    function reviewsCardStep() {
      const card = reviewCards[0];
      const style = card ? getComputedStyle(reviewsTrack) : null;
      const gap = style ? parseFloat(style.columnGap || style.gap || 28) : 28;
      return (card ? card.getBoundingClientRect().width : 360) + gap;
    }
    function reviewsCurrentIndex() {
      return Math.round(reviewsTrack.scrollLeft / reviewsCardStep());
    }
    function reviewsGoTo(index) {
      const total = reviewCards.length;
      const wrapped = (index + total) % total;
      reviewsTrack.scrollTo({ left: wrapped * reviewsCardStep(), behavior: 'smooth' });
    }
    function reviewsScrollBy(dir) { reviewsGoTo(reviewsCurrentIndex() + dir); }
    reviewsPrev.addEventListener('click', () => { reviewsScrollBy(-1); pauseAutoRotate(); });
    reviewsNext.addEventListener('click', () => { reviewsScrollBy(1); pauseAutoRotate(); });

    let reviewsAutoTimer = null;
    let reviewsPauseTimeout = null;
    function startAutoRotate() {
      stopAutoRotate();
      reviewsAutoTimer = setInterval(() => reviewsScrollBy(1), 4500);
    }
    function stopAutoRotate() {
      if (reviewsAutoTimer) { clearInterval(reviewsAutoTimer); reviewsAutoTimer = null; }
    }
    function pauseAutoRotate() {
      stopAutoRotate();
      if (reviewsPauseTimeout) clearTimeout(reviewsPauseTimeout);
      reviewsPauseTimeout = setTimeout(startAutoRotate, 7000);
    }
    ['wheel', 'touchstart', 'pointerdown'].forEach((evt) => {
      reviewsTrack.addEventListener(evt, pauseAutoRotate, { passive: true });
    });

    const reviewsSection = document.querySelector('.reviews');
    if (reviewsSection) {
      const reviewsStartObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startAutoRotate();
            reviewsStartObserver.disconnect();
          }
        });
      }, { threshold: 0.3 });
      reviewsStartObserver.observe(reviewsSection);
    }

    const reviewVideos = document.querySelectorAll('.review-card__video video');
    const reviewsObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play().catch(() => {});
        } else {
          entry.target.pause();
        }
      });
    }, { threshold: 0.35 });
    reviewVideos.forEach((v) => reviewsObserver.observe(v));
  }

  initTwist() {
    const twistSection = document.getElementById('twistSection');
    const twistPause = document.getElementById('twistPause');
    const twistPauseIcon = document.getElementById('twistPauseIcon');
    if (!twistSection || !twistPause || !twistPauseIcon) return;
    const PLAY_ICON = '<path d="M8 5v14l11-7z"/>';
    const PAUSE_ICON = '<rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/>';
    twistPause.addEventListener('click', () => {
      const paused = twistSection.classList.toggle('is-paused');
      twistPauseIcon.innerHTML = paused ? PLAY_ICON : PAUSE_ICON;
      twistPause.setAttribute('aria-label', paused ? 'Play animation' : 'Pause animation');
    });
  }

  initSwitchScroll() {
    const switchViewport = document.querySelector('.switch__viewport');
    const switchTrack = document.getElementById('switchTrack');
    if (!switchViewport || !switchTrack) return;
    function updateSwitchScroll() {
      const rect = switchViewport.getBoundingClientRect();
      const winH = window.innerHeight;
      const delay = winH * 0.6;
      const total = rect.height + winH - delay;
      const progress = Math.min(1, Math.max(0, (winH - rect.top - delay) / total));
      const maxShift = Math.max(0, switchTrack.scrollWidth - switchViewport.clientWidth);
      switchTrack.style.transform = `translateX(-${progress * maxShift}px)`;
    }
    // A continuous rAF loop, not scroll/resize listeners: this theme doesn't
    // reliably fire window 'scroll' events (confirmed by the logo-dock fix),
    // so anything driven by that event alone can get stuck at its start state.
    const loop = () => {
      try {
        updateSwitchScroll();
      } catch (err) {
        console.error('[blakmint-homepage] switch scroll update failed', err);
      }
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }

  initCompareSlider() {
    const compareSec = document.getElementById('compareSec');
    if (!compareSec) return;
    const compareTagLeft = compareSec.querySelector('.compare-sec__tag--left');
    const compareTagRight = compareSec.querySelector('.compare-sec__tag--right');
    let compareDragging = false;
    function setComparePos(clientX) {
      const rect = compareSec.getBoundingClientRect();
      let pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.min(100, Math.max(0, pct));
      compareSec.style.setProperty('--pos', pct + '%');
      if (compareTagLeft) compareTagLeft.style.opacity = pct <= 8 ? 0 : 1;
      if (compareTagRight) compareTagRight.style.opacity = pct >= 92 ? 0 : 1;
    }
    compareSec.addEventListener('pointerdown', (e) => {
      if (e.target.closest('.compare-sec__box')) return;
      compareDragging = true;
      try { compareSec.setPointerCapture(e.pointerId); } catch (err) {}
      setComparePos(e.clientX);
    });
    compareSec.addEventListener('pointermove', (e) => {
      if (!compareDragging) return;
      setComparePos(e.clientX);
    });
    compareSec.addEventListener('pointerup', () => { compareDragging = false; });
    compareSec.addEventListener('pointercancel', () => { compareDragging = false; });
  }

  initLogoDock() {
    const dock = document.getElementById('bmLogoDock');
    const heroSection = document.getElementById('videoHero');
    const heroCopy = document.getElementById('heroCopy');
    let headerLogo = document.querySelector('.header-logo');
    if (!dock || !heroSection || !headerLogo) {
      if (dock) dock.style.display = 'none';
      return;
    }

    const lightImg = dock.querySelector('.bm-logo-dock__light');
    const darkImg = dock.querySelector('.bm-logo-dock__dark');
    const BASE_WIDTH = 440;
    const GAP_ABOVE_COPY = 32;
    const EDGE_PADDING = 16;

    function isMobile() {
      return window.innerWidth <= 640;
    }

    function update() {
      // Re-query every frame: the theme's own JS can re-render the header,
      // which would otherwise leave us holding a stale, detached element.
      headerLogo = document.querySelector('.header-logo') || headerLogo;

      const heroRect = heroSection.getBoundingClientRect();
      const heroHeight = heroRect.height || window.innerHeight;
      const dockDistance = heroHeight * 0.7;
      const progress = Math.min(1, Math.max(0, -heroRect.top / dockDistance));

      const targetRect = headerLogo.getBoundingClientRect();
      const hasValidTarget = targetRect.width > 0 && targetRect.height > 0;

      if (!hasValidTarget) {
        dock.style.opacity = '0';
        return;
      }

      const startWidth = isMobile() ? 340 : BASE_WIDTH;
      let startLeft = isMobile() ? 24 : 64;
      let startTop = window.innerHeight - 220;
      const copyRect = heroCopy ? heroCopy.getBoundingClientRect() : null;
      if (copyRect && copyRect.height > 0 && copyRect.top < window.innerHeight) {
        startLeft = copyRect.left;
        startTop = copyRect.top - GAP_ABOVE_COPY - startWidth * 0.22;
      }
      // heroCopy's own left edge isn't viewport-width-aware, so on narrow
      // screens it can push the dock (sized for mobile) past the right
      // edge — clamp so the logo never starts off-screen.
      if (isMobile()) {
        startLeft = Math.min(startLeft, window.innerWidth - startWidth - EDGE_PADDING);
      }
      startLeft = Math.max(EDGE_PADDING, startLeft);

      const endWidth = targetRect.width;
      const endLeft = targetRect.left;
      const endTop = targetRect.top;

      const width = startWidth + (endWidth - startWidth) * progress;
      let left = startLeft + (endLeft - startLeft) * progress;
      const top = startTop + (endTop - startTop) * progress;

      // Safety clamp for every frame, not just the start position, in case
      // the interpolated width/left ever exceeds the viewport mid-animation.
      const maxLeft = window.innerWidth - width - EDGE_PADDING;
      left = Math.min(left, Math.max(EDGE_PADDING, maxLeft));

      dock.style.width = width + 'px';
      dock.style.transform = `translate(${left}px, ${top}px)`;

      const crossfade = Math.min(1, Math.max(0, (progress - 0.6) / 0.4));
      if (lightImg) lightImg.style.opacity = String(1 - crossfade);
      if (darkImg) darkImg.style.opacity = String(crossfade);

      const docked = progress > 0.97;
      headerLogo.style.opacity = docked ? '1' : '0';
      dock.style.opacity = docked ? '0' : '1';
      dock.style.pointerEvents = 'none';
    }

    headerLogo.style.transition = 'opacity .15s linear';

    // A continuous rAF loop instead of scroll/resize listeners: some themes
    // scroll an inner wrapper rather than the window, which would otherwise
    // leave this permanently frozen at its starting position.
    const loop = () => {
      try {
        update();
      } catch (err) {
        console.error('[blakmint-homepage] logo dock update failed', err);
      }
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }
}
if (!customElements.get('blakmint-homepage')) {
  customElements.define('blakmint-homepage', BlakmintHomepage);
}
